<app-tick-value [value]="value"></app-tick-value>